import React from 'react';
import { Share2 } from 'lucide-react';

import { useApp } from '../../context/AppContext';

import { sendGTMEvent } from '../../utils/analytics';
import { GA4_KEY } from '../../utils/constants';
import { socialIcons } from '../../utils/common';

import CachedImage from '../CachedImage/CachedImage';

import { colors } from '../../styles/colors';
import styles from './ProfileHeader.module.css';

const ProfileHeader = () => {
  const { telegram, user, appDescription } = useApp();

  const {
    avatar,
    description,
    links,
    name,
    stats,
    channel_url,
    mini_app_url,
    referral_text,
  } = appDescription;

  const openChannel = () => {
    const platform = telegram.platform;

    if (platform === 'weba') {
      telegram.openLink(channel_url);
    } else {
      telegram.openTelegramLink(channel_url, '_blank');
    }
  };

  const handleShare = () => {
    telegram.HapticFeedback.impactOccurred('light');
    const url = `${mini_app_url}?startapp=${user.id}`;

    sendGTMEvent(GA4_KEY.share_app);

    // promoHandlerUtility.sendPromoCallback(userData.id);

    const shareUrl = `https://t.me/share/url?url=${encodeURIComponent(
      url
    )}&text=${encodeURIComponent(referral_text)}`;

    const platform = telegram.platform;

    if (platform === 'weba') {
      telegram.openLink(shareUrl);
    } else {
      telegram.openTelegramLink(shareUrl);
    }
  };

  const handleSocialClick = (e, url, platform) => {
    e.preventDefault();
    telegram.HapticFeedback.impactOccurred('light');
    sendGTMEvent(GA4_KEY.open_social_media(platform));
    telegram.openLink(url, {
      try_instant_view: true,
    });
  };

  return (
    <div className={styles.profileHeader}>
      <div className={styles.headerHeader}>
        <button
          className={styles.profilePictureButton}
          onClick={() => {
            if (channel_url) {
              sendGTMEvent(GA4_KEY.open_telegtam_channel);
              window.Telegram.WebApp.HapticFeedback.impactOccurred('light');
              openChannel();
            }
          }}
        >
          <CachedImage
            src={avatar}
            alt='avatar'
            className={styles.profilePicture}
          />
        </button>
        <div className={styles.infoInfo}>
          <div className={styles.profileNameWrapper}>
            <div className={styles.profileNameBadge}>
              <h1 className={styles.profileName}>{name}</h1>
              <svg
                className={styles.verifiedBadge}
                xmlns='http://www.w3.org/2000/svg'
                viewBox='0 0 40 40'
              >
                <path
                  d='M19.998 3.094L14.638 0l-2.972 5.15H5.432v6.354L0 14.64 3.094 20 0 25.359l5.432 3.137v5.905h5.975L14.638 40l5.36-3.094L25.358 40l3.232-5.6h6.162v-6.01L40 25.359 36.905 20 40 14.641l-5.248-3.03v-6.46h-6.419L25.358 0l-5.36 3.094Zm7.415 11.225 2.254 2.287-11.43 11.5-6.835-6.93 2.244-2.258 4.587 4.581 9.18-9.18Z'
                  fill={colors.primary.main}
                  fillRule='evenodd'
                />
              </svg>
            </div>
            <button className={styles.shareButton} onClick={handleShare}>
              <Share2 className={styles.shareIcon} />
            </button>
          </div>

          <div
            className={`${styles.profileStats} ${
              stats?.length < 3 ? styles.small : ''
            }`}
          >
            {stats?.map((stat) => (
              <div
                className={`${styles.stat} ${
                  stats.length < 3 ? styles.small : ''
                }`}
                key={`${stat.key}_${stat.value}`}
              >
                <div
                  className={`${styles.statValue} ${
                    stats.length < 2 ? styles.one : ''
                  }`}
                >
                  {stat.value}
                </div>
                <div
                  className={`${styles.statTitle} ${
                    stats.length < 2 ? styles.one : ''
                  }`}
                >
                  {stat.key}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className={styles.socialIcons}>
        {links?.map((link) => (
          <button
            key={link.type}
            onClick={(e) => handleSocialClick(e, link.url, link.type)}
            className={styles.socialIcon}
          >
            {socialIcons[link.type]}
          </button>
        ))}
      </div>

      <p className={styles.profileBio}>{description}</p>
    </div>
  );
};

export default ProfileHeader;
